import React from "react";
import Container from "react-bootstrap/Container";
import {Alert, Breadcrumb, Col, Row, Table} from "react-bootstrap";
import {Link} from "react-router-dom";
import PFDateAndDesc from "../common/pfDateAndDesc";


const CurrentPF = () => {

    return (
        <>
            <Container fluid>
                <Row>
                    <Col>
                        <h3>
                            <Breadcrumb>
                                <Breadcrumb.Item active>Porchfest 2025</Breadcrumb.Item>
                            </Breadcrumb>
                        </h3>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <Alert variant="primary">
                            <p>
                                <strong>SAVE THE DATE!</strong>
                            </p>
                            <PFDateAndDesc/>
                        </Alert>

                        <p>
                            Winchester's free, one-day performance event is coming back to our community on Saturday
                            June 14, 2025 from 12-5:30pm.
                        </p>

                        <p>
                            <strong>New</strong>&nbsp;<span>&#10024;</span>&nbsp;<span>&#127873;</span>&nbsp;<span>&#127881;</span>
                        </p>
                        <p>
                            This year's porchfest will feature a new website design that lets you:
                        </p>
                        <ul>
                            <li><Link to="/register" reloadDocument="true">Register</Link> as a host or performer and manage your acts and venues yourself</li>
                            <li>Find <Link to="/acts" reloadDocument="true">acts</Link> and <Link to="/venues" reloadDocument="true">venues</Link> as they get added to our site for an up-to-date view of the event</li>
                            <li>Reach out to performers and hosts through our website to arrange for a match</li>
                        </ul>
                        <p>
                            For more information, please see our <Link to="/faq" reloadDocument="true">FAQ</Link> page.
                        </p>
                        <br/>

                        <p>
                            <strong>Important Dates</strong>&nbsp;<span>&#128197;</span>&nbsp;<span>&#128227;</span>&nbsp;<span>&#128204;</span>
                        </p>

                        <Table bordered hover size="lg" responsive>
                            {/*<thead className={`table-primary`}>*/}
                            {/*<tr>*/}
                            {/*    <th  >Activity</th>*/}
                            {/*    <th>Date</th>*/}
                            {/*</tr>*/}
                            {/*</thead>*/}
                            <tbody>
                            <tr>
                                <td width="50%">Registration of hosts and performers begins</td>
                                <td>April 15, 2025</td>
                            </tr>
                            <tr>
                                <td>Registration closes</td>
                                <td>May 24, 2025</td>
                            </tr>
                            <tr>
                                <td>Final porchfest schedule published</td>
                                <td>May 31, 2025</td>
                            </tr>
                            <tr>
                                <td>Porchfest rain day plan announced (if necessary)</td>
                                <td>June 13, 2025</td>
                            </tr>
                            </tbody>
                        </Table>
                        <p>
                            We hope to make the 2025 Winchester Porchfest a success. Please continue to check our
                            website for updates and we hope to see you soon!
                        </p>

                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default CurrentPF;
